<ion-header class="header --w-back-button">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item *ngFor="let breadcrumb of breadcrumbs" class="breadcrumb__item" [routerLink]="[breadcrumb.link]" detail="false">
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="routes.settings" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title>Logo</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content> </ion-content>
